import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'PriceType',
    column_type: 'id',
  },
  created_at: {
    model_name: 'PriceType',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'PriceType',
    column_type: 'datetime',
  },
  name: {
    model_name: 'PriceType',
    column_type: 'string',
  },
  amount: {
    model_name: 'PriceType',
    column_type: 'decimal',
  },
  price_type_template: {
    model_name: 'PriceType',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'price_type_template',
      model_name: 'PriceTypeTemplate',
      foreign_key: 'price_type_template_id',
    },
  },
  price_type_template_id: {
    model_name: 'PriceType',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'price_type_template',
      model_name: 'PriceTypeTemplate',
      foreign_key: 'price_type_template_id',
    },
  },
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
